module.exports = __webpack_public_path__ + "img/weavrwise-logo.80974116.svg";